import { Outlet } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Loader2 } from 'lucide-react';
import { SignInPage } from '@/pages/SignInPage';

/** 路由守卫：未登录时显示登录页，登录后渲染子路由 */
export function RequireAuth() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#040f1d]">
        <Loader2 className="w-8 h-8 animate-spin text-[#58a6ff]" />
      </div>
    );
  }

  if (!isAuthenticated) return <SignInPage />;
  return <Outlet />;
}
